import React from 'react';
import { Container } from '@/components/ui';
import FileImporterFilesManager from './components/FileImporterFilesManager';
import { withPermissions } from '@/components/withPermissions';
import { PERMISSIONS } from '@/types/permissions';
import { usePermissionAccess } from '@/hooks/usePermissionAccess';
import { Link } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import { IconUpload } from '@tabler/icons-react';

const FileImporterFiles: React.FC = () => {
  const canUpload = usePermissionAccess([PERMISSIONS.FILES_UPLOAD]);

  return (
    <Container
      pt="2"
      pb="2"
      size="expand"
      className="file-importer-files-page"
      minHeight="100%"
      style={{
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <FileImporterFilesManager
        canUpload={canUpload}
        customEmptyContent={
          <div className="text-center py-8">
            <div className="max-w-md mx-auto">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <IconUpload size={32} className="text-green-600" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                No files uploaded yet
              </h3>
              <p className="text-gray-600 mb-6">
                {canUpload
                  ? 'Files uploaded through the import process will appear here. Start by uploading files on the main page.'
                  : 'Files uploaded by other users with upload permissions will appear here when available.'}
              </p>
              {canUpload && (
                <Link
                  to={ROUTES.fileImporter}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                >
                  <IconUpload />
                  Go to Upload Page
                </Link>
              )}
            </div>
          </div>
        }
      />
    </Container>
  );
};

export const FileImporterFilesPage = withPermissions(FileImporterFiles, {
  requiredPermissions: [PERMISSIONS.FILES_ACCESS],
  showRoleSwitcher: true,
});
